import Datacapture from './Datacapture';

export default Datacapture; 